/*
 * Copyright (c) 2020 Signum+ Software & Facility GmbH
 * Author: jahn@signum-plus.at
 */

import { ProjectData } from '../model/project.model';
import { ApplicationError, CoreErrorKey, isEmpty, toArray } from '@typescript-kit/core';

export interface TimeRecordProjectValidationOptions {
  projectList: Iterable<ProjectData>;
}

export function validateTimeRecordProject(value: string, options: TimeRecordProjectValidationOptions): boolean {
  if (isEmpty(value)) {
    return true;
  }
  if (options === undefined) {
    throw new ApplicationError({
      key: CoreErrorKey.VALIDATION_OPTIONS_MISSING,
      message: 'Validation options missing'
    });
  }
  if (!options.projectList) {
    return true;
  }

  const projects = toArray(options.projectList);
  const projectNames = value.split(':');

  let parent: ProjectData | undefined;

  for (const projectName of projectNames) {
    const project = projects.find((p) => p.name === projectName && (parent === undefined && !p.parentId || p.parentId === parent.id));
    if (!project || !project.isConfirmed) {
      return false;
    }

    parent = project;
  }

  return true;
}
